import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GruppeTier } from '../classes/gruppe-tier';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogInput } from '../../dialogs/confirm-dialog/confirm-dialog';
import { GruppeTierBemerkungComponent } from '../gruppe-tier-bemerkung/gruppe-tier-bemerkung.component';

@Component({
    selector: 'kiene-gruppe-tier-bemerkung-dialog',
    templateUrl: './gruppe-tier-bemerkung-dialog.component.html',
    styleUrls: ['./gruppe-tier-bemerkung-dialog.component.scss'],
})
export class GruppeTierBemerkungDialogComponent implements OnInit {
    tier: GruppeTier;
    @ViewChild(GruppeTierBemerkungComponent) bemerkungComponent: GruppeTierBemerkungComponent;

    constructor(
        public dialogRef: MatDialogRef<GruppeTierBemerkungDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
    ) {
        this.tier = data.tier;
    }

    ngOnInit(): void {}

    onCancelClick(): void {
        // Prüfe, ob Text im Eingabefeld steht
        const currentValue = this.bemerkungComponent?.bemerkungenAutocomplete?.formControl?.value;

        if (currentValue && currentValue.trim() !== '') {
            // Bestätigungsdialog anzeigen
            const confirmData = new ConfirmDialogInput();
            confirmData.headline = 'Bemerkung nicht speichern?';
            confirmData.text = 'Es steht noch Text im Eingabefeld. Möchten Sie die Bemerkung wirklich nicht speichern?';
            confirmData.okButton = 'Nicht speichern';
            confirmData.cancelButton = 'Abbrechen';
            confirmData.buttonColor = 'warn';

            const confirmDialog = this.dialog.open(ConfirmDialogComponent, { data: confirmData, width: '400px' });

            confirmDialog.afterClosed().subscribe(result => {
                if (result?.confirmed) {
                    this.dialogRef.close();
                }
            });
        } else {
            // Direkt schließen, wenn kein Text vorhanden
            this.dialogRef.close();
        }
    }

    onSaveClick(): void {
        // Prüfe, ob Text im Eingabefeld steht
        const currentValue = this.bemerkungComponent?.bemerkungenAutocomplete?.formControl?.value;

        if (currentValue && currentValue.trim() !== '') {
            // Automatisch die Bemerkung hinzufügen
            this.bemerkungComponent.addBemerkung(currentValue);
            // Das Eingabefeld leeren
            this.bemerkungComponent.bemerkungenAutocomplete.formControl.setValue('');
        }

        // Dann speichern - verwende die gleiche Logik wie bemerkungenHinzufuegen
        this.bemerkungComponent.gruppeTierService.update(this.bemerkungComponent.tier).subscribe({
            next: resp => {
                this.bemerkungComponent.tier = resp;
                this.dialogRef.close(this.bemerkungComponent.tier);
            },
            error: err => {
                this.bemerkungComponent.messageService.errorMessage('Fehler beim Speichern der Bemerkungen!', err);
            },
        });
    }
}
